import { request } from "./api";

export const apiCall = (method, url, data = null) => request(method, url, data);
export const addUser = (userData) => apiCall("POST", "/users", userData);
export const updateUser = (id, userData) => apiCall("PUT", `/users/${id}`, userData);
export const deleteUser = (id) => apiCall("DELETE", `/users/${id}`);
export const deleteTentative = (id) => apiCall("DELETE", `/tentatives/${id}`);

export const approveTentative = async (id, userData) => {
  const userResponse = await addUser(userData);
  if (userResponse.status === 200) return deleteTentative(id);
  return userResponse;
};
